var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tag-filter" }, [
    _c(
      "ul",
      { staticClass: "tag-filter__list" },
      _vm._l(_vm.tags, function(tag) {
        return _c("li", { key: tag.Id, staticClass: "tag-filter__item" }, [
          _c(
            "button",
            {
              staticClass: "tag__button",
              class: {
                "tag__button--active": _vm.selectedTags.includes(tag.Name)
              },
              attrs: { id: tag.Id },
              on: {
                click: function($event) {
                  return _vm.emitCategory(tag.Name)
                }
              }
            },
            [
              _vm._v("\n        " + _vm._s(tag.Name) + "\n        "),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.selectedTags.includes(tag.Name)
                  ? _c("span", { staticClass: "tag__icon" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "",
                            height: "",
                            viewBox: "0 0 64 64"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              "data-name": "Rectangle 105",
                              fill: "none",
                              d: "M0 0h64v64H0z"
                            }
                          }),
                          _c("path", {
                            attrs: {
                              "data-name": "Icon-Cross",
                              d:
                                "M59.24 8.331a2.37 2.37 0 00.76-1.78 2.49 2.49 0 00-.76-1.83 2.45 2.45 0 00-1.79-.72 2.57 2.57 0 00-1.82.72L32 28.391 8.33 4.721a2.44 2.44 0 00-1.78-.72 2.58 2.58 0 00-1.83.72A2.58 2.58 0 004 6.551a2.44 2.44 0 00.72 1.78l23.67 23.67-23.67 23.63a2.57 2.57 0 00-.72 1.82 2.45 2.45 0 00.72 1.79 2.49 2.49 0 001.83.76 2.37 2.37 0 001.78-.76L32 35.611l23.63 23.63a2.49 2.49 0 001.82.76 2.6 2.6 0 002.55-2.55 2.49 2.49 0 00-.76-1.82l-23.63-23.63z"
                            }
                          })
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }